import { FormRadioButtonGroup, RadioButton, Typography } from 'omakase';
import { QuestionOptionalTextField } from 'forms/previsit-questions/QuestionOptionalTextField';
import { QuestionRadioResponse } from '@tock/shared/utils/questionUtils';
import { core } from '@tock/coretypes';
import { getOptionsFromQuestion } from 'forms/previsit-questions/questionOptions';
import { useField } from 'formik';

interface Props {
  name: string;
  question: core.TicketTypeQuestion;
}

/**
 * FormRadioButtonGroup control with a label and configurable free form text
 * entry
 */
export const QuestionRadioGroupField = ({ name, question }: Props) => {
  const [, { value }] = useField<QuestionRadioResponse>(name);
  const options = getOptionsFromQuestion(question);
  if (!value) {
    return null;
  }

  return (
    <div data-testid="pre-visit-question">
      <Typography variant="body02" data-testid="pre-visit-question-label">
        {question.text}
      </Typography>
      <FormRadioButtonGroup
        label={question.text}
        disclosureMode="static"
        name={`${name}.value`}
        hideLabel
      >
        {options.map((option) => (
          <RadioButton
            name={`${name}.value`}
            value={option.text}
            label={option.text}
            key={option.text}
            data-testid="pre-visit-question-radio"
          />
        ))}
      </FormRadioButtonGroup>
      <QuestionOptionalTextField name={name} question={question} value={value.value} />
    </div>
  );
};
